import { render, staticRenderFns } from "./BankCardConfirmAmount.vue?vue&type=template&id=b8a01560"
import script from "./BankCardConfirmAmount.vue?vue&type=script&lang=ts"
export * from "./BankCardConfirmAmount.vue?vue&type=script&lang=ts"
import style0 from "./BankCardConfirmAmount.vue?vue&type=style&index=0&id=b8a01560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports